import { InputAdornment, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { Func } from '@/utils/ts';

export interface SearchInputProps {
  'data-test'?: string;
  className?: string;
  onChange: Func<[string]>;
  inputRef?: React.Ref<HTMLElement>;
}

const SearchInput: React.FC<SearchInputProps> = ({ className, onChange, 'data-test': dataTest, inputRef }) => {
  const [searchText, setSearchText] = useState<string>('');
  const { formatMessage } = useIntl();
  return (
    <TextField
      inputRef={inputRef}
      className={className}
      variant="standard"
      inputProps={{
        style: {
          padding: '12px',
          fontSize: '13px',
          lineHeight: '17px',
        },
      }}
      /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
      // @ts-ignore
      InputLabelProps={{ 'data-test': dataTest && `${dataTest}-label` }}
      /* eslint-disable-next-line react/jsx-no-duplicate-props */
      InputProps={{
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        'data-test': dataTest && `${dataTest}-input`,
        disableUnderline: true,
        startAdornment: (
          <InputAdornment
            position="end"
            style={{
              marginLeft: '16px',
            }}
          >
            <SearchIcon style={{ color: '#999BBF' }} />
          </InputAdornment>
        ),
      }}
      placeholder={formatMessage({ id: 'common.components.search.placeholder' })}
      onChange={async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        const inputValue = event.target.value;
        if (inputValue !== searchText) {
          setSearchText(inputValue);
          onChange(inputValue);
        }
      }}
    />
  );
};

export default SearchInput;
